import { render, staticRenderFns } from "./DialogTaoPhieuThuTienMat.vue?vue&type=template&id=21fd92b6"
import script from "./DialogTaoPhieuThuTienMat.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuThuTienMat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports